import React from "react";
import ContactForm from "../../components/contact-us";

const ContactAll = () => {
  return <ContactForm />;
};

export default ContactAll;
